import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SystemSelectionPage from './components/SystemSelectionPage';
import SystemDetailPage from './components/SystemDetailPage';
import './styles.css';

const AsthmaTracker = () => {
  return (
    <Routes>
      <Route path="/" element={<SystemSelectionPage />} />
      <Route path="/:systemName" element={<SystemDetailPage />} />
    </Routes>
  );
};

export default AsthmaTracker; 